import { DEFAULT_RPC_SEEDS, type RpcSeed } from '@gonka-wallet/chain';
import type { ChainNodeSource } from '@gonka-wallet/storage';

/**
 * Resolve the list of RPC seeds to use for chain queries based on the
 * user's settings. If the user selected a custom node URL, build a
 * single-seed list pointing at their URL with no path prefix (the
 * custom node is responsible for its own path layout and CORS). If
 * they use the default Gonka Hub source, return DEFAULT_RPC_SEEDS
 * which points at the same-origin /api/chain reverse proxy.
 *
 * This helper is used by useBalance, useHistory, AND useSignAndBroadcast
 * so that all three chain-touching hooks respect the same chain node
 * source. Previously the three hooks duplicated this logic and
 * useSignAndBroadcast silently ignored the user's custom URL.
 */
export function resolveSeeds(
  source: ChainNodeSource,
  customUrl: string | null,
): readonly RpcSeed[] {
  if (source === 'custom' && customUrl) {
    return [{ url: customUrl, pathPrefix: '', label: 'Custom node' }];
  }
  return DEFAULT_RPC_SEEDS;
}
